export const environment = {
    production: false,
    msal: {
        auth: {
            clientId: 'c5316992-c03c-4bb6-997b-9e497128e2a7',
            directoryID: 'f2fda5e7-2ea1-450d-9fc1-2af5f8630095',
        }
    }
};
 